interface TourNavigationPromptController {
  hasActiveTour: () => boolean
  prepare: () => void
  confirm: () => Promise<void> | void
  cancel: () => void
}

let activeController: TourNavigationPromptController | null = null

export const registerTourNavigationPromptController = (controller: TourNavigationPromptController) => {
  activeController = controller

  return () => {
    if (activeController === controller) {
      activeController = null
    }
  }
}

export const prepareTourNavigationPrompt = () => {
  if (!activeController?.hasActiveTour()) {
    return false
  }

  activeController.prepare()
  return true
}

export const confirmTourNavigationPrompt = async () => {
  await activeController?.confirm()
}

export const cancelTourNavigationPrompt = () => {
  activeController?.cancel()
}
